import * as React from 'react';
import styles from '../../styles/flyouts/stages/Substages.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router-dom';
import {
  __,
  dateFrom,
  getLocalized,
  setTableParams,
  validateForm,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { getURLParam } from '../../core/utils';
import classNames from 'classnames';
import { ReactSortable } from 'react-sortablejs';
import GrabberIcon from '../../assets/images/grabber-16x16.svg';
import { connect } from 'react-redux';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import Tooltip from '../../components/Tooltip';
import EditIcon from '../../assets/images/edit-16x16.svg';
import { readStage } from '../../redux/actions/table/stages';
import {
  deleteSubstage,
  updateSubstageOrder,
} from '../../redux/actions/table/substages';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';

const Substages = ({
  data,
  collapsed,
  is_project_administrator,
  application_language_id,
}) => {
  const handleReorder = (newOrder) => {
    setTableParams('stages', {
      flyout: {
        ...data,
        substages: _.map(newOrder, (substage, i) => ({
          ...substage,
          order: i,
        })),
      },
    });
  };

  const handleEdit = (substage) => {
    setTableParams('substages', {
      edit_substage_wizard: substage,
    });
  };

  const handleDelete = (substageId) => {
    const stage_id = data.id;

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __('stage.substages.delete-substage.alert.are-you-sure'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteSubstage(stage_id, substageId).then(() => {
              hideAlertbox();

              readStage(stage_id);

              setNotification(
                __(
                  'stage.substages.delete-substage.notification.substage-deleted'
                )
              );
            });
          },
        },
      ],
    });
  };

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      {/* --- HEADER --- */}
      <div className={classNames(styles.row, styles.header)}>
        <span className={styles.expand} />
        <span className={styles.name}>{__('stage.substages.name')}</span>

        <span className={styles.dates}>{__('stage.substages.dates')}</span>
        <span className={styles.description}>
          {__('stage.substages.description')}
        </span>
        <span className={styles.duration}>
          {__('stage.substages.duration')}
        </span>
        <span className={styles.status}>{__('stage.substages.status')}</span>
        <span className={styles.edit} />
        <span className={styles.delete} />
      </div>
      {!_.isEmpty(data.substages) ? (
        <ReactSortable
          list={_.sortBy(data.substages, 'order')}
          setList={(list) => handleReorder(list)}
          animation={200}
          delayOnTouchStart={true}
          onEnd={(items) => {
            updateSubstageOrder(
              data.id,
              _.map(_.sortBy(data.substages, 'order'), 'id')
            );
          }}
          disabled={!is_project_administrator}
        >
          {_.map(data.substages, (substage, index) => (
            <div key={substage.id} className={styles.row}>
              {is_project_administrator && (
                <span className={styles.grabber}>
                  <GrabberIcon />
                </span>
              )}
              <span className={styles.name}>
                {getLocalized(substage?.name, application_language_id)}
              </span>
              <span className={styles.dates}>
                {dateFrom(substage.start_date)} - {dateFrom(substage.end_date)}
              </span>
              <span className={styles.description}>
                {getLocalized(substage?.description, application_language_id)}
              </span>
              <span className={styles.duration}>{substage.duration}</span>
              <span className={styles.status}>
                {substage.status === 0
                  ? __('stage.substages.status.started')
                  : __('stage.substages.status.finished')}
              </span>
              {is_project_administrator ? (
                <>
                  <span
                    className={styles.edit}
                    onClick={() => {
                      handleEdit(substage);
                    }}
                  >
                    <Tooltip text={__(__('stage.substages.edit-element'))}>
                      <EditIcon />
                    </Tooltip>
                  </span>
                  <span
                    className={styles.delete}
                    onClick={() => {
                      handleDelete(substage.id);
                    }}
                  >
                    <Tooltip text={__(__('stage.substages.delete-element'))}>
                      <DeleteIcon />
                    </Tooltip>
                  </span>
                </>
              ) : (
                <>
                  <span className={styles.move} />
                  <span className={styles.delete} />
                </>
              )}
            </div>
          ))}
        </ReactSortable>
      ) : (
        <div className={styles.emptyState}>
          {__('stage.substages.no_substages')}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    application_language_id: state.auth.language_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Substages));
